import { render } from "./svg-tag.vue?vue&type=template&id=63c5b932"
import script from "./svg-tag.vue?vue&type=script&lang=ts"
export * from "./svg-tag.vue?vue&type=script&lang=ts"
script.render = render

export default script